import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

const noop = () => {};

const PageSearchContext = createContext({
  query: "",
  setQuery: noop,
  clearQuery: noop,
});

export const PageSearchProvider = ({ children }) => {
  const location = useLocation();
  const [query, setQuery] = useState("");

  useEffect(() => {
    setQuery("");
  }, [location.pathname]);

  const value = useMemo(
    () => ({
      query,
      setQuery,
      clearQuery: () => setQuery(""),
    }),
    [query],
  );

  return <PageSearchContext.Provider value={value}>{children}</PageSearchContext.Provider>;
};

export const usePageSearch = () => useContext(PageSearchContext);
